import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { PrimaryButton, styleVariables } from '@lib/common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var CollapseContainer = styled.div.withConfig({
  displayName: "question-list-reviewcomponent__CollapseContainer",
  componentId: "sc-1asjzo5-0"
})(["height:40%;background:", ";box-shadow:0px 3px 6px rgba(0,0,0,0.12);padding:24px 24px 0 24px;border-radius:16px;display:flex;flex-direction:column;overflow:scroll;::-webkit-scrollbar{width:0;}"], styleVariables.colors.gray1);
var SectionReviewContainer = styled.div.withConfig({
  displayName: "question-list-reviewcomponent__SectionReviewContainer",
  componentId: "sc-1asjzo5-1"
})(["width:100%;display:flex;justify-content:center;padding:16px;border:1px solid ", ";border-radius:8px;display:flex;flex-direction:column;margin-bottom:24px;cursor:pointer;border:1px solid ", ";"], styleVariables.colors.gray9, function (props) {
  return props.active ? styleVariables.colors.blue4 : styleVariables.colors.gray9;
});
var SectionReviewHeaderContainer = styled.div.withConfig({
  displayName: "question-list-reviewcomponent__SectionReviewHeaderContainer",
  componentId: "sc-1asjzo5-2"
})(["display:flex;align-items:center;justify-content:space-between;margin-bottom:", ";"], function (props) {
  return props.activeStatus ? '16px' : "".concat(props.margin, "px") || 0;
});
var SectionReviewTitle = styled.span.withConfig({
  displayName: "question-list-reviewcomponent__SectionReviewTitle",
  componentId: "sc-1asjzo5-3"
})(["font-size:16px;font-weight:600;"]);
var SectionReviewSubTitle = styled.span.withConfig({
  displayName: "question-list-reviewcomponent__SectionReviewSubTitle",
  componentId: "sc-1asjzo5-4"
})(["font-size:14px;font-weight:400;color:", ";"], styleVariables.colors.gray10);
var QuestionListReviewContainer = styled.div.withConfig({
  displayName: "question-list-reviewcomponent__QuestionListReviewContainer",
  componentId: "sc-1asjzo5-5"
})(["flex-wrap:wrap;gap:12px;display:inline-flex;width:100%;"]);
var QuestionReviewBox = styled.div.withConfig({
  displayName: "question-list-reviewcomponent__QuestionReviewBox",
  componentId: "sc-1asjzo5-6"
})(["width:44px;height:40px;border-radius:8px;display:flex;align-items:center;justify-content:center;background:", ";color:", ";border:", ";border:1px solid ", ";color:", ";&:hover{border:1px solid ", ";color:", ";}"], function (props) {
  return props.edited && styleVariables.colors.blue1;
}, function (props) {
  return props.edited && styleVariables.colors.blue4;
}, function (props) {
  return props.edited && 0;
}, function (props) {
  return props.active ? styleVariables.colors.blue3 : styleVariables.colors.gray9;
}, function (props) {
  return props.active && styleVariables.colors.blue3;
}, styleVariables.colors.blue3, styleVariables.colors.blue3);
var Container = styled.div.withConfig({
  displayName: "question-list-reviewcomponent__Container",
  componentId: "sc-1asjzo5-7"
})(["height:800px;overflow-y:scroll;::-webkit-scrollbar{width:0;}"]);
var EndTimeButton = styled(PrimaryButton).withConfig({
  displayName: "question-list-reviewcomponent__EndTimeButton",
  componentId: "sc-1asjzo5-8"
})(["width:100%;height:48px;margin-top:24px;border-color:", ";background:", ";"], styleVariables.colors.blue3, styleVariables.colors.blue3);
export var QuestionListReviewComponent = function QuestionListReviewComponent(props) {
  var sections = props.sections,
      sectionSelectedIndex = props.sectionSelectedIndex,
      onUpdateSectionSelected = props.onSelectedSection,
      onSelectQuestion = props.onSelectedQuestion,
      questionsEdited = props.questionsEdited,
      endTime = props.endTime,
      onSubmitSubmission = props.onSubmitSubmission,
      questionSelectedIndex = props.questionSelectedIndex;

  var _useState = useState(false),
      isEndTimeBtnLoading = _useState[0],
      setIsEndTimeBtnLoading = _useState[1]; // const endTimeFormat = moment.unix(parseInt(endTime));


  var onHandleSubmit = function onHandleSubmit() {
    setIsEndTimeBtnLoading(true);
    onSubmitSubmission();
  };

  var generateQuestionEditedClass = useCallback(function (sectionIndex, questionIndex) {
    var questionEditedClass = questionsEdited && questionsEdited.find(function (q) {
      return q.sectionIndex === sectionIndex + 1 && q.questionIndex === questionIndex;
    });
    return !!questionEditedClass;
  }, [questionsEdited]);
  var generateQuestionEditedNumber = useCallback(function (sectionIndex) {
    var questionsEditedNumber = questionsEdited && questionsEdited.filter(function (q) {
      return q.sectionIndex === sectionIndex;
    }).length;
    return questionsEditedNumber || 0;
  }, [questionsEdited]);

  var SectionReview = function SectionReview(props) {
    var sectionIndex = props.sectionIndex,
        questions = props.questions,
        totalQuestion = props.totalQuestion;
    return /*#__PURE__*/_jsxs(SectionReviewContainer, {
      active: sectionSelectedIndex === sectionIndex + 1,
      children: [/*#__PURE__*/_jsxs(SectionReviewHeaderContainer, {
        onClick: function onClick() {
          return onUpdateSectionSelected(sectionIndex + 1);
        },
        activeStatus: true,
        children: [/*#__PURE__*/_jsxs(SectionReviewTitle, {
          children: ["Ph\u1EA7n ", sectionIndex + 1]
        }), /*#__PURE__*/_jsxs(SectionReviewSubTitle, {
          children: ["Tr\u1EA3 l\u1EDDi ", generateQuestionEditedNumber(sectionIndex + 1), "/", totalQuestion]
        })]
      }), /*#__PURE__*/_jsx(QuestionListReviewContainer, {
        children: questions.map(function (_, questionIndex) {
          return /*#__PURE__*/_jsx(QuestionReviewBox, {
            onClick: function onClick() {
              return onSelectQuestion(sectionIndex + 1, questionIndex);
            },
            edited: generateQuestionEditedClass(sectionIndex, questionIndex),
            active: questionSelectedIndex === questionIndex && sectionSelectedIndex === sectionIndex + 1,
            children: questionIndex + 1
          }, questionIndex);
        })
      })]
    });
  };

  var questionsGenerate = function questionsGenerate(length) {
    return Array.from({
      length: length
    }, function (_, i) {
      return {
        key: i,
        description: '',
        score: 0
      };
    });
  };

  useEffect(function () {
    if (endTime) setIsEndTimeBtnLoading(true);
  }, [endTime]);
  return /*#__PURE__*/_jsxs(CollapseContainer, {
    children: [/*#__PURE__*/_jsx(SectionReviewHeaderContainer, {
      margin: 16,
      children: /*#__PURE__*/_jsx(SectionReviewTitle, {
        children: "Danh s\xE1ch c\xE2u h\u1ECFi"
      })
    }), /*#__PURE__*/_jsx(Container, {
      children: sections.map(function (section, sectionIndex) {
        var totalQuestion = section.totalQuestion;
        return /*#__PURE__*/_jsx(SectionReview, {
          sectionIndex: sectionIndex,
          questions: questionsGenerate(totalQuestion),
          totalQuestion: totalQuestion
        }, sectionIndex);
      })
    }), /*#__PURE__*/_jsx(SectionReviewHeaderContainer, {
      children: /*#__PURE__*/_jsx(EndTimeButton, {
        block: true,
        htmlType: "submit",
        loading: isEndTimeBtnLoading && !endTime,
        disabled: isEndTimeBtnLoading,
        onClick: onHandleSubmit,
        children: "N\u1ED9p b\xE0i"
      })
    })]
  });
};